import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Http } from '@angular/http';
import { ConfigProvider } from '../../providers/config/config';
import { TranslateService } from '@ngx-translate/core';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { LoadingProvider } from '../../providers/loading/loading';
import { AlertProvider } from '../../providers/alert/alert';
import { OrderDetailPage } from '../order-detail/order-detail';
import { CartPage } from '../cart/cart';
import { SearchPage } from '../search/search';
import { HomePage } from '../home/home';
import { Home2Page } from '../home2/home2';
import { Home3Page } from '../home3/home3';
import { Home4Page } from '../home4/home4';
import { Home5Page } from '../home5/home5';


@Component({
  selector: 'page-my-installs',
  templateUrl: 'my-installs.html',
})
export class MyInstallsPage {
  orders = new Array;
  loadedorders = new Array;
  httpRunning = true;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public http: Http,
    public config: ConfigProvider,
    public shared: SharedDataProvider,
    translate: TranslateService,
    public alert: AlertProvider,
    public loading: LoadingProvider
  ) {
  }
  getItems(searchbar){
    // Reset items back to all of the items
    this.initializeItems();
    // set q to the value of the searchbar
    var q = searchbar.srcElement.value;

    // if the value is an empty string don't filter the items
     if (!q) {
       return;
     }

     this.orders = this.orders.filter((v) => {

   if(v.customers_name && q) {
     if (v.customers_name.toLowerCase().indexOf(q.toLowerCase()) > -1) {
       return true;
     }
     return false;
   }
 });


  };

  initializeItems(): void {
  this.orders = this.loadedorders;
}
  getInstalls() {
    this.httpRunning = true;
    this.orders = [];
    this.loadedorders = [];
    this.loading.show();
    var data: { [k: string]: any } = {};
    data.customers_id = this.shared.customerData.customers_id;
    data.language_id = this.config.langId;
    this.http.post(this.config.url + 'getUpcomingInstalls', data).map(res => res.json()).subscribe(data => {
      this.loading.hide();
      this.httpRunning = false;
      //$rootScope.address=response.data.data;
      if (data.success == 1) {
        console.log("Orders:",data);
        this.orders = [];
        this.orders = data.data;
        this.loadedorders = this.orders;
      }
      // $scope.$broadcast('scroll.refreshComplete');
    },
      function (response) {
        this.loading.hide();
        this.alert.show("Server Error while Loading Orders");
        console.log(response);
      });
  };

  showOrderDetail(order) {

    this.navCtrl.push(OrderDetailPage, { 'data': order });

  }
  ionViewDidLoad() {
    this.httpRunning = true;
    this.getInstalls();
  }
  openCart() {
    this.navCtrl.push(CartPage);
  }
  openSearch() {
    this.navCtrl.push(SearchPage);
  }
  openHomePage() {

    if (this.config.homePage == 1) { this.navCtrl.setRoot(HomePage); }
    if (this.config.homePage == 2) { this.navCtrl.setRoot(Home2Page); }
    if (this.config.homePage == 3) { this.navCtrl.setRoot(Home3Page); }
    if (this.config.homePage == 4) { this.navCtrl.setRoot(Home4Page); }
    if (this.config.homePage == 5) { this.navCtrl.setRoot(Home5Page); }
  }
}



// WEBPACK FOOTER //
// ./src/pages/my-installs/my-installs.ts